module.exports = __webpack_public_path__ + "static/media/bruce1.0761d6d9.mp3";